import React, { useCallback, useEffect, useMemo, useState } from "react";
import {
  Container,
  Row,
  Col,
  Button,
  FormGroup,
  InputGroup,
  FormControl,
  // Dropdown,
  // FormLabel
} from "react-bootstrap";
// import { Link } from "react-router-dom";
import { injectIntl } from 'react-intl';
import Alert from "react-s-alert";
import { DateTime } from "luxon";
import { queryCache, useMutation, useQuery } from "react-query";
import { Formik, Form, Field } from "formik";
import { useHistory } from "react-router-dom";
//
import PageLoading from "../../../components/Loading";
import AddedPresentation from "../../../components/AddedPresentation";
import UserDetails from "../../../components/UserDetails";
import ProgressContainer from "./progress-container";
import EventCard from './event-card';

import CreateItemForm from '../../../components/CreateItemForm'

import VirtualTable from '../../../components/TableNew/virtual-table';

import { ReactSelect } from "../../../formik";

import SortButton from "../../../components/SortButton";
import { getEventBootstrap, getEventPresentations, putPresentation, putPresentationFile, deletePresentationFile, deletePresentation } from "./xhr";
import { getSchedule } from '../schedules/xhr'
import getAwsS3FileUrl from "../../../helpers/getAwsS3FileUrl";

const Presentations = ({ match, intl, locale, setLocale }) => {
  const [showEmailModal, setShowEmailModal] = useState(false);
  const [search, setSearch] = useState("");
  const [sort, setSort] = useState("datetime");
  const [order, setOrder] = useState("dec");
  const [presentationName, setPresentationName] = useState('');

  const [showFilters, setShowFilters] = useState(false);

  const [showSort, setShowSort] = useState(false);

  const [filterValuesTable, setFilterValuesTable] = useState({});

  let history = useHistory();

  const { isLoading: isLoading0, isError: isError0, error: error0, data } = useQuery(['event-bootstrap', match && match.params && match.params.id], getEventBootstrap, {
    onError: (err) => {
      Alert.error(intl.formatMessage({ id: err.response.data.message }))
    }
  });


  console.log("PLAY DATA", data);

  const { isLoading, isError, error, data: presentations } = useQuery(['event-presentations', match && match.params && match.params.id], getEventPresentations, {
    onError: (err) => {
      Alert.error(intl.formatMessage({ id: err.response.data.message }))
    }
  });

  const { data: scheduleData } = useQuery('schedule', getSchedule);

  const [putPresentationMutation] = useMutation(putPresentation, {
    onSuccess: (updatedPresentation) => {
      if (queryCache.getQueryData(['event-presentations', updatedPresentation.event_id])) {
        queryCache.setQueryData(['event-presentations', updatedPresentation.event_id], presentations => presentations
          .map(presentation => presentation._id === updatedPresentation._id ? updatedPresentation : presentation)
        )
        queryCache.setQueryData(['presentation', updatedPresentation._id], () => updatedPresentation)
      }
      Alert.success(intl.formatMessage({ id: 'presentation.update-success' }));
    },
    onError: (err) => {
      Alert.error(intl.formatMessage({ id: err.response.data.message }))
    }
  })

  const [putPresentationFileMutation] = useMutation(putPresentationFile, {
    onSuccess: (updatedPresentation) => {
      if (queryCache.getQueryData(['event-presentations', updatedPresentation.event_id])) {
        queryCache.setQueryData(['event-presentations', updatedPresentation.event_id], presentations => presentations
          .map(presentation => presentation._id === updatedPresentation._id ? updatedPresentation : presentation)
        )
        queryCache.setQueryData(['presentation', updatedPresentation._id], () => updatedPresentation)
      }
      Alert.success(intl.formatMessage({ id: 'presentation.update-success' }));
    },
    onError: (err) => {
      Alert.error(intl.formatMessage({ id: err.response.data.message }))
    }
  })

  const [deletePresentationFileMutation] = useMutation(deletePresentationFile, {
    onSuccess: (updatedPresentation) => {
      if (queryCache.getQueryData(['event-presentations', updatedPresentation.event_id])) {
        queryCache.setQueryData(['event-presentations', updatedPresentation.event_id], presentations => presentations
          .map(presentation => presentation._id === updatedPresentation._id ? updatedPresentation : presentation)
        )
        queryCache.setQueryData(['presentation', updatedPresentation._id], () => updatedPresentation)
      }
      Alert.success(intl.formatMessage({ id: 'presentation.update-success' }));
    },
    onError: (err) => {
      Alert.error(intl.formatMessage({ id: err.response.data.message }))
    }
  })

  const [deletePresentationMutation] = useMutation(deletePresentation, {
    onSuccess: (deletedPresentation) => {
      if (queryCache.getQueryData(['event-presentations', deletedPresentation.event_id])) {
        queryCache.setQueryData(['event-presentations', deletedPresentation.event_id], presentations => presentations
          .filter(presentation => presentation._id !== deletedPresentation._id)
        )

        queryCache.invalidateQueries(['presentation', deletedPresentation._id]);
      }
      Alert.success(intl.formatMessage({ id: 'presentation.delete-success' }));
    },
    onError: (err) => {
      Alert.error(intl.formatMessage({ id: err.response.data.message }))
    }
  })

  const columns = useMemo(
    () => {
      if (!data) {
        return []
      }

      const { event, speakers, rooms } = data;

      return [
        {
          Header: 'Rooms',
          accessor: ({ _id, ...row }) => {
            const speaker = speakers.find(s => s._id === row.speaker_id)
            const room = rooms.find(r => r._id === row.room_id);
            return [
              row.name,
              speaker ? `${speaker.title || ''} ${speaker.firstName} ${speaker.lastName}` : '',
              room ? room.name : '',
            ].join("|")
          },
          Cell: ({ cell: { value }, row: { original } }) => {
            // <pre>{JSON.stringify(original, null, 2)}</pre>
            const speaker = speakers.find((f) => f._id === original.speaker_id);
            const room = rooms.find((f) => f._id === original.room_id);
            return <AddedPresentation
              putPresentationMutation={putPresentationMutation}
              deletePresentationMutation={deletePresentationMutation}
              putPresentationFileMutation={putPresentationFileMutation}
              deletePresentationFileMutation={deletePresentationFileMutation}
              presentation={original}
              room={room}
              i={original.i}
              intl={intl}
              speaker={speaker}
              bgColor={event.schedule_background_color}
              editLink={`/manage-event/${original.event_id}/edit/${original._id}`}
              eventSlug={event.slug}
              show_video_views={event.show_video_views}
            />
          },
        },
      ]
    },
    [data, intl, putPresentationMutation, putPresentationFileMutation, deletePresentationFileMutation, deletePresentationMutation]
  )

  const downloadAllPresentations = () => {
    Alert.warning(
      intl.formatMessage({
        id: "label.allow-popups-multiple-downloads",
      })
    );
    setTimeout(() => {
      presentations
        // .filter((p) => {
        //   return (
        //     this.state.filterById === "" ||
        //     p.room_id === this.state.filterById
        //   );
        // })
        .map(async (p) => {
          if (p.ppt.length > 0) {
            const fileURL = await getAwsS3FileUrl(p.ppt[p.ppt.length - 1].file)
            window.open(fileURL, "_blank");
          }
          return p;
        });
    }, 3000);
  }

  const statusNumber = useCallback((s) => {
    switch (s) {
      case "no-ppt":
        return 1;
      case "ppt-uploaded":
        return 2;
      case "recording":
        return 3;
      case "video-recorded":
        return 4;
      default:
        return 5;
    }
  }, []);

  const AutoSubmit = ({ values, submitForm }) => {
    useEffect(() => {
      submitForm()
    }, [values, submitForm])

    return null
  }

  const sortOptions = useMemo(() => {
    if (!data) {
      return []
    }

    const { speakers } = data;
    return [
      {
        label: 'input.presentation.status', value: 'status', sort: (a, b) => {
          return statusNumber(b.status) - statusNumber(a.status);
        }
      },
      {
        label: 'input.presentation.datetime', value: 'datetime',
        sort: (a, b) => {
          const [ah, am] = a.time.split(":").map(n => parseInt(n));
          const [bh, bm] = b.time.split(":").map(n => parseInt(n));
          return (DateTime.fromISO(b.date).toSeconds() + bh * 60 * 60 + bm * 60) - (DateTime.fromISO(a.date).toSeconds() + ah * 60 * 60 + am * 60)
        },
      },
      { label: 'input.presentation.name', value: 'name', sort: (a, b) => a.name.localeCompare(b.name) },
      {
        label: 'input.firstname', value: 'speaker_firstname', sort: (a, b) => {
          const speakerA = speakers.find((f) => f._id === a.speaker_id);
          const speakerB = speakers.find((f) => f._id === b.speaker_id);
          return speakerA.firstName.localeCompare(speakerB.firstName)
        }
      },
      {
        label: 'input.lastname', value: 'speaker_lastname', sort: (a, b) => {
          const speakerA = speakers.find((f) => f._id === a.speaker_id);
          const speakerB = speakers.find((f) => f._id === b.speaker_id);
          return speakerA.lastName.localeCompare(speakerB.lastName)
        }
      },
      // {
      //   label: 'input.presentation.room', value: 'room_id', sort: (a, b) => {
      //     const roomA = rooms.find((f) => f._id === a.room_id);
      //     const roomB = rooms.find((f) => f._id === b.room_id);
      //     return roomA.name.localeCompare(roomB.name);
      //   }
      // },
      // {
      //   label: 'input.presentation.isPublic', value: 'public', sort: (a, b) => {
      //     return b.public - a.public;
      //   }
      // },
      // {
      //   label: 'input.presentation.pdfConvert', value: 'pdfConvert', sort: (a, b) => {
      //     return b.pdfConvert - a.pdfConvert;
      //   }
      // },
      // {
      //   label: 'input.presentation.publicVideo', value: 'publicVideo', sort: (a, b) => {
      //     return b.publicVideo - a.publicVideo;
      //   }
      // },
      // {
      //   label: 'label.pptVersion', value: 'ppt.length', sort: (a, b) => {
      //     return b.ppt.length - a.ppt.length;
      //   }
      // },
      // {
      //   label: 'label.pptSize', value: 'pptSize', sort: (a, b) => {
      //     return b.pptSize - a.pptSize;
      //   }
      // },
    ]
  }, [data, statusNumber]);

  if (isLoading0 || isLoading) {
    return <PageLoading />;
  }

  if (isError0) {
    return <span>Error: {error0.message}</span>
  }

  if (isError) {
    return <span>Error: {error.message}</span>
  }

  const uniqRooms = [...new Set(presentations.map(i => i.room_id))];

  const uniqStatus = [...new Set(presentations.map(i => i.status))];

  const { event, speakers, rooms } = data;

  return (
    <React.Fragment>
      <Container fluid className="pad-0">
        <Row className="no-gutters user-details-cont user-details-cont-presentation">
          <Col md={8}>
            <Row className="align-items-center p-t-20">
              <Col lg={5} xl={4} >
                <h2 className="font-grey m-l-header">
                  {presentations && presentations.length} {intl.formatMessage({ id: 'total.presentations.created' })}
                  {/* <span className="total-video-views">{intl.formatMessage({id: 'total.video.views'})}: <b>1200</b></span> */}
                </h2>
              </Col>
              <Col lg={7} xl={8}>
                {
                  presentations && <div className="view-desk-large"><ProgressContainer intl={intl} presentations={presentations} /></div>
                }
              </Col>
            </Row>
          </Col>
          <Col md={4}>
            <div className="text-right">
              <Button onClick={() => history.goBack()} className="btn-return-fixed btn-btn-primary">
                retour
              </Button>
              <UserDetails locale={locale} setLocale={setLocale} intl={intl} />
            </div>
          </Col>
        </Row>
      </Container>
      <div className="pad-2rem">
        <Container fluid>
          <Row>
            <Col md={12}>
              <Row>
                <Col md={9}>
                  {
                    presentations && <div className="view-desk-small"><ProgressContainer intl={intl} presentations={presentations} /></div>
                  }
                </Col>
              </Row>

              {/* This is the box where creating a new presentation button exist */}
              <Row className="align-items-center m-t-30 m-b-30">
                <Col xl={6}>
                  <CreateItemForm
                    heading="button.createPresentation"
                    setFunc={setPresentationName}
                    placeholder="Nom de la présentation"
                    link={`/manage-event/${match.params.id}/add/${presentationName}`}
                  />
                </Col>

                {/* search sort area in presentation page */}
                <Col xl={6}>
                  <Row className="align-items-center">
                    <Col md={6}>
                      <div className="search-container m-t-0">
                        <FormGroup className="m-b-0">
                          <InputGroup onChange={(e) => {
                            setSearch(e.target.value)
                          }}>
                            <FormControl type="text" />
                            <InputGroup.Append>
                              <Button>
                                <img src="/icons/search.png" alt="plus" />
                              </Button>
                            </InputGroup.Append>
                          </InputGroup>
                        </FormGroup>
                      </div>
                    </Col>
                    <Col md={6}>
                      <div className="dropdown-filters">
                        {/* <FormGroup controlId="sort" className="sort-filter">
                          <img className="sort-icon" alt="" src="/icons/list.png" />
                          <FormControl onChange={(e) => setSort(e.target.value)} as="select">
                            <option selected disabled>trier</option>
                            {
                              sortOptions.map((o, i) => (
                                <option key={i} value={o.value} selected={o.value === sort}>{intl.formatMessage({ id: o.label })}</option>
                              ))
                            }
                          </FormControl>
                        </FormGroup> */}
                        <SortButton
                          showSort={showSort}
                          setShowSort={setShowSort}
                          sortOptions={sortOptions}
                          intl={intl}
                          sort={sort}
                          setSort={setSort}
                          order={order}
                          setOrder={setOrder}
                        />
                        <Button onClick={() => setShowFilters(!showFilters)} className={`filter-btn ${showFilters ? 'filter-open' : ''}`}>
                          <img src="/icons/icon-filter.svg" alt="filter" />
                          {
                            !showFilters ? <i className="fas fa-chevron-down"></i> : <i className="fas fa-chevron-up"></i>
                          }
                        </Button>
                      </div>
                    </Col>
                  </Row>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Formik
                    onSubmit={(values) => setFilterValuesTable(values)}
                    initialValues={{
                      status: '',
                      room_id: '',
                      public: false,
                      pdfConvert: false,
                      publicVideo: false,
                    }}
                  >
                    {({ values: filterValues, submitForm }) => {
                      return (
                        <div className={`filter-container ${showFilters ? 'show-filter' : 'no-filter'}`}>
                          <Form>
                            <Row>
                              <Col lg={3}>
                                <Field
                                  component={ReactSelect}
                                  name="status"
                                  isMulti={false}
                                  placeholder={intl.formatMessage({
                                    id: "input.presentation.status",
                                  })}
                                  label={intl.formatMessage({
                                    id: "input.presentation.status",
                                  })}
                                  options={[{ value: "", label: "All" }].concat(uniqStatus.map((s) => {
                                    return {
                                      value: s,
                                      label: intl.formatMessage({ id: `ppt-status.${s}` }),
                                    };
                                  }))}
                                />
                              </Col>

                              <Col lg={4}>
                                <Field
                                  component={ReactSelect}
                                  name="room_id"
                                  isMulti={false}
                                  placeholder={intl.formatMessage({
                                    id: "form.select.room",
                                  })}
                                  label={intl.formatMessage({
                                    id: "form.select.room",
                                  })}
                                  options={[{ value: "", label: "All" }].concat(uniqRooms.map((r) => {
                                    const room = rooms.find((f) => f._id === r);
                                    return {
                                      value: r,
                                      label: room ? room.name : ''
                                    }
                                  }))}
                                />
                              </Col>
                            </Row>
                            <Row>
                              {/*                               
                              <Col>
                              <RadioButtonGroup

                                id="bool"
                                required
                              >
                                <Field
                                  component={RadioButton}
                                  name="bool"
                                  id="isPublic"
                                  label={intl.formatMessage({ id: 'select.displayMode.public' })}
                                  value="isPublic"
                                />
                                <Field
                                  component={RadioButton}
                                  name="bool"
                                  id="pdfConvert"
                                  label="Conversion PDF"
                                  value="pdfConvert"
                                />
                                <Field
                                  component={RadioButton}
                                  name="bool"
                                  id="publicVideo"
                                  label={intl.formatMessage({ id: 'input.presentation.publicVideo' })}
                                  value="publicVideo"
                                />
                              </RadioButtonGroup>
                            </Col> */}
                              <Col>
                                <Field
                                  component={ReactSelect}
                                  name="public"
                                  isMulti={false}
                                  placeholder={intl.formatMessage({
                                    id: "input.event.displayMode",
                                  })}
                                  label={intl.formatMessage({
                                    id: "input.event.displayMode",
                                  })}
                                  options={
                                    [
                                      { value: "", label: "All" },
                                      { value: "true", label: intl.formatMessage({ id: 'select.displayMode.public' }) },
                                      { value: "false", label: intl.formatMessage({ id: 'select.displayMode.password' }) }
                                    ]
                                  }
                                />
                                {/* <Field
                                component={ReactSwitch}
                                name="public"
                                id="public"
                                onColor="#fa7c16"
                                label={intl.formatMessage({
                                  id: "select.displayMode.public",
                                })}
                              /> */}
                              </Col>
                              <Col>
                                <Field
                                  component={ReactSelect}
                                  name="pdfConvert"
                                  isMulti={false}
                                  placeholder={intl.formatMessage({
                                    id: "input.presentation.pdfConvert",
                                  })}
                                  label={intl.formatMessage({
                                    id: "input.presentation.pdfConvert",
                                  })}

                                  options={
                                    [
                                      { value: "", label: "All" },
                                      { value: "true", label: intl.formatMessage({ id: 'yes' }) },
                                      { value: "false", label: intl.formatMessage({ id: 'no' }) }
                                    ]
                                  }
                                />
                                {/* <Field
                                component={ReactSwitch}
                                name="pdfConvert"
                                id="pdfConvert"
                                onColor="#fa7c16"
                                label={intl.formatMessage({
                                  id: "input.presentation.pdfConvert",
                                })}
                              /> */}
                              </Col>
                              <Col>
                                <Field
                                  component={ReactSelect}
                                  name="publicVideo"
                                  isMulti={false}
                                  placeholder={intl.formatMessage({
                                    id: "input.presentation.publicVideo",
                                  })}
                                  label={intl.formatMessage({
                                    id: "input.presentation.publicVideo",
                                  })}
                                  options={
                                    [
                                      { value: "", label: "All" },
                                      { value: "true", label: intl.formatMessage({ id: 'yes' }) },
                                      { value: "false", label: intl.formatMessage({ id: 'no' }) }
                                    ]
                                  }
                                />
                                {/* <Field
                                component={ReactSwitch}
                                name="publicVideo"
                                onColor="#fa7c16"
                                id="publicVideo"
                                label={intl.formatMessage({
                                  id: "input.presentation.publicVideo",
                                })}
                              /> */}
                              </Col>
                            </Row>
                            <AutoSubmit values={filterValues} submitForm={submitForm} />
                          </Form>
                        </div>
                      )
                    }}
                  </Formik>
                  {/* Each presentations listed here inside the virtual table */}
                  <VirtualTable
                    columns={columns}
                    data={presentations
                      .filter((row) => filterValuesTable.status ? row.status === filterValuesTable.status : true)
                      .filter((row) => filterValuesTable.room_id ? row.room_id === filterValuesTable.room_id : true)
                      .filter((row) => filterValuesTable.public ? row.public.toString() === filterValuesTable.public : true)
                      .filter((row) => filterValuesTable.pdfConvert ? row.pdfConvert.toString() === filterValuesTable.pdfConvert : true)
                      .filter((row) => filterValuesTable.publicVideo ? row.publicVideo.toString() === filterValuesTable.publicVideo : true)
                      .sort(sortOptions.find((so) => so.value === sort).sort)
                      .map((d, i) => ({
                        ...d, i: i
                          * (order === "dec" ? -1 : 1) //Diljith Krishna - 2026-01-27 - Fixed sort order issue
                      }))
                      .sort((a, b) => a.i - b.i)}
                    search={search}
                    match={match}
                    pageSize={presentations.length}
                  />
                </Col>

                {/* Right side box area which includes the navigation to event site (engagement-side) */}
                <Col lg={4} xl={3}>
                  <EventCard
                    presentations={presentations}
                    speakersProps={speakers}
                    rooms={rooms}
                    scheduleData={scheduleData}
                    showEmailModal={showEmailModal}
                    setShowEmailModal={(bool) => setShowEmailModal(bool)}
                    downloadAllPresentations={downloadAllPresentations}
                    event={event}
                    intl={intl} />
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default injectIntl(Presentations);
